import {
  TextField,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  OutlinedInput,
  Box,
  Chip
} from '@mui/material';
import { commonCheckboxStyles, commonChipStyles, commonOutlinedInputStyles, selectedChipStyles, commonMenuItemStyles } from '../../helpers/InfoTableHelper'; // Adjust path as needed

const TableValueInput = ({ row, index, isEditing, handleValueChange }) => {
  const { value, type, choices } = row.information;

  if (!isEditing) {
    if (type === "boolean") {
      return value ? "Yes" : "No";
    } else if (Array.isArray(value)) {
      if (value.length === 0) return "-----";
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: 'center', fontFamily: 'inherit' }}>
          {value.map((item) => (
            <Chip
              key={item}
              label={item}
              size="small"
              variant="outlined"
              sx={commonChipStyles}
            />
          ))}
        </Box>
      );
      }
    return value;
  }

  // editing mode
  switch (type) {
    case "boolean":
    return (
      <Checkbox
        checked={!!value} // ensures value is a boolean
        onChange={(e) => handleValueChange(e, index, type)}
        size="medium"
        sx={{ padding: '8px', ...commonCheckboxStyles }}
      />
    );
    case "choice":
      const displayValue =
        value === null ||
        value === "" ||
        value.length === 0 ||
        (typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0)
          ? "-----"
          : value;

      const finalChoices = choices?.some((c) => c === null)
        ? choices
        : [null, ...(choices || [])];

    return (
      <FormControl
        variant="outlined"
        sx={{ m: 0, width: "100%" }}
        size="small"
      >
        <Select
          value={displayValue}
          onChange={(e) => handleValueChange(e, index, type)}
          MenuProps={{ PaperProps: { style: { width: 250 } } }}
          sx={commonOutlinedInputStyles}
        >
          {finalChoices.map((choice, idx) => (
            <MenuItem
              key={idx}
              value={choice === null ? "-----" : choice}
              sx={commonMenuItemStyles}
            >
              {choice === null ? "-----" : choice}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      );
    case "multi":
    return (
      <FormControl variant="outlined" sx={{ m: 0, width: "100%" }} size="small">
        <Select
          multiple
          value={Array.isArray(value) ? value : []} // ensures value is an array
          onChange={(e) => handleValueChange(e, index, type)}
          input={<OutlinedInput />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  size="small"
                  sx={selectedChipStyles}
                />
              ))}
            </Box>
          )}
          MenuProps={{
            PaperProps: {
              style: {
                width: 250
              },
            },
          }}
          sx={commonOutlinedInputStyles}
        >
          {choices.map((choice, idx) => (
            <MenuItem key={idx} value={choice} sx={{ fontFamily: 'inherit' }}>
              <Checkbox
                checked={value.indexOf(choice) > -1}
                sx={commonCheckboxStyles}
              />
                {choice}
            </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
    case "int":
    return (
      <TextField
        size="small"
        variant="outlined"
        type="number"
        value={value === null || value === '' ? '' : value}
        onChange={(e) => handleValueChange(e, index, type)}
        placeholder="0"
        sx={commonOutlinedInputStyles}
        InputProps={{
          inputProps: {
            min: 0
          },
          sx: {
            fontFamily: 'inherit'
          }
        }}
      />
    );
    case "string":
    default:
      return (
        <TextField
          size="small"
          variant="outlined"
          placeholder="Value"
          value={value || ''}
          onChange={(e) => handleValueChange(e, index, type)}
          sx={commonOutlinedInputStyles}
          multiline
          InputProps={{ sx: { fontFamily: 'inherit' } }}
        />
      );
  }
};

export default TableValueInput;